/**
 * "7 copies", over a listing photo.
 *
 * A reseller often lists several copies of the same item -- a DVD shop with
 * seven of one title. The search APIs send `copies` (live listings that
 * seller has of this item, this one included) so a shopper can tell at a
 * glance the item is not a one-off.
 *
 * Top-left of the photo because it is the one corner free on both cards: the
 * status / percent-off badge owns top-right, the condition badge bottom-right,
 * and the row card's wishlist heart bottom-left. Same pill as the condition
 * badge, so the photo carries one badge style rather than two. Those colours
 * sit on the photo, not on the page, so they read the same in both themes.
 *
 * One component so the two cards cannot drift (see percent-off-badge.tsx).
 */
const ListingCopiesBadge = ({ copies }: { copies?: number }) => {
  // One copy is the normal case and says nothing; no number at all means the
  // API did not send it (older response, or a list that does not count).
  if (typeof copies !== 'number' || !Number.isFinite(copies) || copies < 2) {
    return null;
  }
  return (
    <div
      className="absolute top-2 left-2 z-[3] font-semibold text-gray-600 bg-gray-100 px-2 py-1 rounded"
      data-testid="listing-copies"
      aria-label={`${copies} copies available from this seller`}
    >
      {copies} copies
    </div>
  );
};

export default ListingCopiesBadge;
